let currentId = 0

function nextId() {
  return ++currentId
}

export {nextId}